import api from "../../../../../BasicComponent/Service/api";
import { DEVICETYPE_URL } from "../../../../utils/constService";

export const fetchDeviceType = (params = {}) => {
  return api.get(DEVICETYPE_URL, { params });
};
export const fetchDeviceTypeForFilter = () => {
  return api.get(`${DEVICETYPE_URL}/get-all`);
};
export const postDeviceType = (data) => {
  return api.post(DEVICETYPE_URL, data);
};

export const putDeviceType = (data, deviceTypeId) => {
  return api.put(`${DEVICETYPE_URL}/${deviceTypeId}`, data);
};

export const deleteDeviceType = (deviceTypeId) => {
  return api.delete(`${DEVICETYPE_URL}/${deviceTypeId}`);
};
export const deviceConnectDisconnectApiCall = (uuid, connect) =>
  api.post(`${DEVICETYPE_URL}/connect/${uuid}`, null, {
    params: { connect },
  });
